(function ($, Cobalt, undefined) {
    var _insertCallback;
    var _managerModal;
    var _modalOpen = false;
    var _isEditMode = false;
    Cobalt.PostWidget = {
        currentPostID: null,
        showPostWidgets: true,
        dependentScripts: function () {
            return [{ dependency: Cobalt.User, name: "Cobalt.User" }, { dependency: Cobalt.UI, name: "Cobalt.UI" }, { dependency: Cobalt.Tabs, name: "Cobalt.Tabs" }, { dependency: Cobalt.Listing, name: "Cobalt.Listing"}];
        },
        defaultMarkup: "<curse_postwidget data-slug=\"{0}\" data-config=\"{1}\" />",

        initialize: function () {
        },
        postWidgetReady: function () {
        },
        showLoading: function () {
           
            _managerModal.addClass("loading");
        },
        hideLoading: function () {
            _managerModal.removeClass("loading");
        },
        hideModal: function (isSave) {
            if (_managerModal.length > 0) {
                _managerModal.dialog("destroy");
                _managerModal.remove();

                if (typeof tinyMCE !== 'undefined' && tinyMCE.activeEditor != null) {

                    if (!isSave || isSave === undefined) { //only performed when not saving
                        //hacky - to get tinymce to re-enter content into dom
                        $(".b-tab-item[data-markup-mode='markup']").click();
                        $(".b-tab-item[data-markup-mode='editor']").click();
                    }

                    tinyMCE.activeEditor.execCommand("mceRepaint");

                }

                $(".ui-dialog-titlebar-close").off("click");
            }
        },
        showWidgetEditor: function (postWidgetLoadedCallback, postwidgetSlug, config) {

            var $widgetUL = $("ul#postWidgets");
            $widgetUL.hide();
            Cobalt.PostWidget.showLoading();

            var sentData = {
                config: config,
                postID: Cobalt.PostWidget.currentPostID
            };

            $.ajax({
                type: "POST",
                data: sentData,
                url: '/ajax/posts/widgets/' + postwidgetSlug,
                dataType: 'html',
                success: function (data) {
                    // Fadeout placeholder with callback to fade in the configuration form
                    var $formWrapper = $("<div\>").addClass("postwidget-editor");
                    var $form = $(data);
                    $form.appendTo($formWrapper);
                    Cobalt.PostWidget.hideLoading();
                    if (!_isEditMode) {
                        $formWrapper.hide();
                    }

                    $("#postwidget-manager").append($formWrapper);

                    // Wire up Cancel button
                    $("#postwidget-manager").on('click', '#field-cancel', function (e) {
                        e.preventDefault();

                        if (_isEditMode) {
                            Cobalt.PostWidget.hideModal();
                        }

                        $formWrapper.fadeOut(function () {
                            $("#postwidget-manager").off('submit');
                            $formWrapper.remove();
                            $widgetUL.fadeIn();
                        });
                        return false;
                    });

                    // Wire up submit button to retrieve settings from hidden config
                    $("#postwidget-manager").on('submit', 'form.post-widget-form', function (e) {
                        e.preventDefault();
                        var configString = $('#field-config').val();
                        Cobalt.PostWidget.hideModal(true);
                        _insertCallback(Cobalt.PostWidget.defaultMarkup.format(postwidgetSlug, configString));
                        return false;
                    });

                    if (!_isEditMode) {
                        $widgetUL.fadeOut(function () {
                            $formWrapper.fadeIn(function () {

                            });
                        });
                    }
                    Cobalt.triggerHtmlInsert($("#postwidget-manager"));
                    postWidgetLoadedCallback();
                    Cobalt.PostWidget.postWidgetReady();
                },
                error: function (e) {
                    alert('Error loading configuration editor for widget');
                    Cobalt.PostWidget.hideLoading();
                    return false;
                }
            });
        },
        showWidgets: function (callback, postWidgetLoadedCallback, slug, config) {

            Cobalt.PostWidget.showLoading();            

            $.get('/ajax/posts/widgets', function (data) {
                Cobalt.PostWidget.hideLoading();
                var $widgetList = $(data);

                $('body').on("click", "ul#postWidgets > li:not(.selected) div.wrapper", function (e) {
                    e.stopImmediatePropagation();
                    setTimeout(function () { $(".instructions").fadeOut("slow"); }, 500);
                    if ($.cookie("Cobalt.PostWidgetManager.instructions") == null) {
                        $.cookie("Cobalt.PostWidgetManager.instructions", "1", { path: "/", expires: 365 });
                    }

                    // Get the clicked widget                   
                    var $clickedWidget = $(this);
                    var postwidgetSlug = $clickedWidget.parents("li.postwidget").attr("data-slug");
                    Cobalt.PostWidget.showWidgetEditor(postWidgetLoadedCallback, postwidgetSlug);
                });

                var $managerDiv = _managerModal.find('#postwidget-manager');
                _managerModal.append($widgetList);

                var $widgetUL = $("ul#postWidgets");
                $widgetUL.hide();


                if (_isEditMode) {
                    Cobalt.PostWidget.showWidgetEditor(postWidgetLoadedCallback, slug, config);
                    Cobalt.triggerHtmlInsert($managerDiv);
                }
                else {
                    $widgetUL.fadeIn(function () {
                        Cobalt.triggerHtmlInsert($widgetUL);
                    });
                }
                callback();
            });
        },
        showModal: function (target, insertCallback, postWidgetSlug, config) {

            _isEditMode = config != null;
            _insertCallback = insertCallback;
            try {
                _managerModal = $('<div>');
                _managerModal.dialog({ title: "Configure Post Widget", modal: true, position: "center", resizable: false, draggable: false, dialogClass: "modal modal-post-widget-manager", width: 865, height: 540, close: Cobalt.PostWidget.hideModal });
                _managerModal.parent().center({ fixed: true, absolute: true, sizeToWindow: true, maxWidth: 865, maxHeight: 540 });

                Cobalt.PostWidget.showWidgets(function () {
                    if ($("#postwidget-manager").length > 0) {
                        $(".ui-dialog-titlebar-close").on("click", function (e) {
                            e.preventDefault();
                            Cobalt.PostWidget.hideModal();
                        });
                    }
                    if ($.cookie("Cobalt.PostWidgetManager.instructions") == null) {
                        if (!postWidgetSlug) {
                            setTimeout(function () { $(".instructions").fadeIn("slow"); }, 1000);
                        }
                    }
                }, function () {
                    if (config) {
                        $("#field-config").val(config);
                    }
                }, postWidgetSlug, config);
            } catch (e) { }

            $([document, window]).bind('keyup', function (e) {
                if (e.keyCode == "27") {
                    Cobalt.PostWidget.hideModal();
                }
            });

        }

    }

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.PostWidget.js